// eslint-disable-next-line
import { injectable } from "inversify";
import { rootContainer, TYPE } from "../container/root";
import { IApiResponse, IHttpService } from "../http-service";
import {WithOld} from "../../stores/types";

export interface ITranslationsService {
    getScope(scope: string): Promise<ITranslationScope>;
    saveTranslations(data: WithOld<{ payload: ITranslationRecord[] }, 'payload'>): Promise<boolean>;
    deleteTranslations(data: WithOld<{ payload: ITranslationRecord[] }, 'payload'>): Promise<boolean>;
    getTranslationsStatus(): Promise<ITranslationsStatus>;
}

export interface ITranslationsStatus {
    has_missing_translations: boolean
}

export interface ILocale {
    locale: string,
    is_enabled: boolean,
}

export interface ITranslationScope {
    default_locale: string;
    locales: ILocale[];
    translations: ITranslationRecord[];
    hints: IHintsMap[];
}

export interface IHintsMap {
    [key: string]: { hint: string; }
}


export interface ITranslationRecord {
    is_customizable?: boolean,
    key: string,
    locale: string,
    priority?: string,
    scope: string,
    translation: string,
    type?: string,

    _deteted?: boolean;
}

@injectable()
class TranslationsService implements ITranslationsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async getScope(scope: string): Promise<ITranslationScope> {
        const response = await this.httpService.get<IApiResponse<ITranslationScope>>(`/rms-api/translations/${scope}`);
        return response.payload;
    }

    public async saveTranslations(data: WithOld<{ payload: ITranslationRecord[] }, 'payload'>): Promise<boolean> {
        const res = await this.httpService.post<IApiResponse<boolean>>(`/rms-api/translations`, data);
        return res.payload;
    }

    public async deleteTranslations(records: WithOld<{ payload: ITranslationRecord[] }, 'payload'>): Promise<boolean> {
        const res = await this.httpService.post<IApiResponse<boolean>>(`/rms-api/translations/delete`, records);
        return res.payload;
    }

    public async getTranslationsStatus(): Promise<ITranslationsStatus> {
        const res = await this.httpService.get<IApiResponse<ITranslationsStatus>>(`/rms-api/translations-status`);
        return res.payload;
    }

}


export default TranslationsService;
